import React, { Component, Fragment } from 'react';
import { Grid } from '@material-ui/core';

interface ErrorBoundaryState {
    hasError: boolean;
}

interface ErrorBoundaryProps {
    classes?: any;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            hasError: false
        };
    }

    public static getDerivedStateFromError = ((): object => {
        return { hasError: true };
    });

    public render(): any {
        if (!this.state.hasError) {
            return this.props.children;
        }

        return (
            <Fragment>
                <Grid container spacing={0} justify='center' alignItems='center' direction='column'>
                    <Grid item xs={12}>
                        <h2>Oops! Something went wrong.</h2>
                    </Grid>
                </Grid>
            </Fragment>
        );
    }

}

export default ErrorBoundary;
